import {
  removeTransactionFromTable,
  UPDATE_TABLE_SUCCESS,
  LOADING_TABLE
} from './table'
import { UPDATE_BAR_SUCCESS, DELETE_BAR_SUCCESS, deleteBar } from './bar'
import moment from 'moment'
import _ from 'lodash'
import { MODAL_CLIENT_PAYMENT, showModal } from './modals'
import {
  calculsTransaction,
  calculTotalBillard
} from 'utils/PriceCalculHelpers'
import {
  createNewTransactionForPool,
  addCycle,
  editCycle,
  deleteCycle,
  createNewTransactionForBar
} from 'redux/helpers/transactionHelpers'
import { recordFromSnapshot } from 'utils/firebaseUtils'

// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_TRANSACTION_ERROR = 'CREATE_TRANSACTION_ERROR'
export const CREATE_TRANSACTION_SUCCESS = 'CREATE_TRANSACTION_SUCCESS'
export const DELETE_TRANSACTION_ERROR = 'DELETE_TRANSACTION_ERROR'
export const DELETE_TRANSACTION_SUCCESS = 'DELETE_TRANSACTION_SUCCESS'
export const UPDATE_TRANSACTION_ERROR = 'UPDATE_TRANSACTION_ERROR'
export const UPDATE_TRANSACTION_SUCCESS = 'UPDATE_TRANSACTION_SUCCESS'
export const CLEAR_CURRENT_TRANSACTION = 'CLEAR_CURRENT_TRANSACTION'
export const SELECT_CURRENT_TRANSACTION = 'SELECT_CURRENT_TRANSACTION'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function addProductsToTransaction(transaction, products) {
  return (dispatch, getState) => {
    const { users, firebase } = getState()
    const fanout = {}
    for (let i = 0; i < products.length; i++) {
      const key = firebase
        .child(`transactions/${transaction.key}/products/`)
        .push().key
      const product = { ...products[i] }
      product.createdBy = users.currentUser.key
      product.createdAt = moment().format()
      product.updatedBy = users.currentUser.key
      product.updatedAt = moment().format()
      product.initPrice = products[i].initPrice
        ? products[i].initPrice
        : products[i].price
      product.productKey = products[i].key
      delete product.key
      fanout[`transactions/${transaction.key}/products/${key}`] = product
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function addConso(transaction, product) {
  return (dispatch, getState) => {
    const { users, firebase } = getState()
    const key = firebase
      .child(`transactions/${transaction.key}/products/`)
      .push().key
    product.createdBy = users.currentUser.key
    product.createdAt = moment().format()
    product.updatedBy = users.currentUser.key
    product.updatedAt = moment().format()
    delete product.id_sale_product_detail
    delete product.key
    const fanout = {}
    fanout[`transactions/${transaction.key}/products/${key}`] = product
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}

export function removeConso(transaction, product) {
  return (dispatch, getState) => {
    const { users, firebase } = getState()
    const fanout = {
      [`transactions/${transaction.key}/products/${
        product.key
      }/deletedBy`]: users.currentUser.key
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function changeReducConso(transaction, product, reduc) {
  return (dispatch, getState) => {
    const { firebase, users } = getState()
    const changedProduct = { ...product }
    const newPrice =
      reduc === 0
        ? product.initPrice
        : _.round(
            Number(product.initPrice) - Number(product.initPrice) * reduc / 100,
            2
          ).toFixed(2)
    changedProduct.updatedAt = moment().format()
    changedProduct.updatedBy = users.currentUser.key
    changedProduct.price = newPrice
    changedProduct.reduc = reduc === 0 ? null : reduc
    const fanout = {}
    fanout[
      `transactions/${transaction.key}/products/${product.key}`
    ] = changedProduct
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
    // dispatch(updateTransaction(transaction, changes))
  }
}
export function addSideTable(table) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const transac = table.currentTransaction
    if (transac) {
      const fanout = {}
      fanout[`transactions/${transac.key}/isSided`] = true
      return firebase.update(fanout, error => {
        if (error) {
          Rollbar.error(error)
        }
      })
      // dispatch(updateTransaction(transac, { isSided: true }))
    } else {
      dispatch(createTransactionForPool(table))
    }
  }
}
export function removeSideTable(transaction) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const fanout = {}
    fanout[`transactions/${transaction.key}/isSided`] = false
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
    // dispatch(updateTransaction(transaction, { isSided: false }))
  }
}
export function removePlayer(transaction) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const players = [...transaction.pool.players]
    players.pop()

    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/nbPlayers`] = players.length
    fanout[`transactions/${transaction.key}/pool/players`] = players
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function createCycle(transaction, pricing) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const cycles = addCycle(transaction, pricing)
    const changes = { pool: { ...transaction.pool, cycles: cycles } }
    const total = calculTotalBillard(changes)
    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles

    if (total !== Number(transaction.pool.total)) {
      fanout[`transactions/${transaction.key}/pool/total`] = total
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function removeCycle(transaction, cycle) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const cycles = deleteCycle([...transaction.pool.cycles], cycle)
    const changes = { pool: { ...transaction.pool, cycles: cycles } }
    const total = calculTotalBillard(changes)
    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles

    if (total !== Number(transaction.pool.total)) {
      fanout[`transactions/${transaction.key}/pool/total`] = total
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function updateCycle(transaction, cycle) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const cycles = editCycle([...transaction.pool.cycles], cycle)
    const changes = { pool: { ...transaction.pool, cycles: cycles } }
    const total = calculTotalBillard(changes)
    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles

    if (total !== Number(transaction.pool.total)) {
      fanout[`transactions/${transaction.key}/pool/total`] = total
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function updateCyclePlayers(transaction, key, players) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    let nbPlayers = 0
    players.map(p => {
      nbPlayers += p.count
      return p
    })
    const cycle = { ...transaction.pool.cycles[key] }
    cycle.playersCount = nbPlayers
    cycle.players = players
    const cycles = editCycle([...transaction.pool.cycles], cycle)
    const changes = { pool: { ...transaction.pool, cycles: cycles } }
    const total = calculTotalBillard(changes)
    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles

    if (total !== Number(transaction.pool.total)) {
      fanout[`transactions/${transaction.key}/pool/total`] = total
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function updateCycleStartDate(transaction, key, startDate) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const cycle = { ...transaction.pool.cycles[key] }
    cycle.startDate = startDate
    const cycles = editCycle([...transaction.pool.cycles], cycle)
    const changes = { pool: { ...transaction.pool, cycles: cycles } }
    const total = calculTotalBillard(changes)
    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles

    if (total !== Number(transaction.pool.total)) {
      fanout[`transactions/${transaction.key}/pool/total`] = total
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function updateCyclePricing(transaction, key, pricing) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const cycle = { ...transaction.pool.cycles[key] }
    cycle.pricing = {
      key: pricing.key,
      name: pricing.name,
      type: pricing.type,
      value: pricing[transaction.pool.table.type]
    }
    const cycles = editCycle([...transaction.pool.cycles], cycle)
    const changes = { pool: { ...transaction.pool, cycles: cycles } }
    const total = calculTotalBillard(changes)
    const fanout = {}
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles

    if (total !== Number(transaction.pool.total)) {
      fanout[`transactions/${transaction.key}/pool/total`] = total
    }
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function prepareForPayment(transaction) {
  return (dispatch, getState) => {
    const { firebase, users } = getState()
    return new Promise((resolve, reject) => {
      const changes = { ...transaction }
      const fanout = {}
      const now = moment().format()
      let totals = calculsTransaction(changes)
      if (transaction.pool) {
        fanout[`transactions/${transaction.key}/pool/sync`] = true
        changes.pool.sync = true
      }
      if (transaction.type === 'POOL' && transaction.pool) {
        if (
          !changes.pool.cycles[changes.pool.cycles.length - 1].endDate &&
          !changes.pool.isPaused
        ) {
          fanout[`transactions/${transaction.key}/pool/isPaused`] = true
          fanout[
            `transactions/${transaction.key}/pool/cycles/${changes.pool.cycles
              .length - 1}/pauseDate`
          ] = now
          fanout[
            `transactions/${transaction.key}/pool/cycles/${changes.pool.cycles
              .length - 1}/endDate`
          ] = now
          changes.pool.isPaused = true
          changes.pool.cycles[changes.pool.cycles.length - 1].pauseDate = now
          changes.pool.cycles[changes.pool.cycles.length - 1].endDate = now
        } else if (
          !changes.pool.cycles[changes.pool.cycles.length - 1].endDate &&
          changes.pool.isPaused
        ) {
          fanout[
            `transactions/${transaction.key}/pool/cycles/${changes.pool.cycles
              .length - 1}/endDate`
          ] =
            changes.pool.cycles[changes.pool.cycles.length - 1].pauseDate || now
        }
        totals = calculsTransaction(changes)
        changes.pool.totalElapsed = totals.elapsed
        fanout[`transactions/${transaction.key}/pool/totalElapsed`] =
          totals.elapsed
        if (totals.totalCurrentBillard !== Number(transaction.pool.total)) {
          changes.pool.total = totals.totalCurrentBillard
          changes.pool.sync = false
          fanout[`transactions/${transaction.key}/pool/total`] =
            totals.totalCurrentBillard
          fanout[`transactions/${transaction.key}/pool/sync`] = false
        }
        fanout[`transactions/${transaction.key}/total`] = _.round(
          Number(totals.total),
          2
        )
        changes.total = _.round(Number(totals.total), 2)
      }
      if (transaction.type === 'BAR' && transaction.pool) {
        fanout[`transactions/${transaction.key}/total`] = _.round(
          Number(totals.totalProducts + transaction.pool.total),
          2
        )
        changes.total = _.round(
          Number(totals.totalProducts + transaction.pool.total),
          2
        )
      } else if (transaction.type === 'BAR' && !transaction.pool) {
        fanout[`transactions/${transaction.key}/total`] = _.round(
          Number(totals.totalProducts),
          2
        )
        changes.total = _.round(Number(totals.totalProducts), 2)
      }
      changes.updatedBy = users.currentUser.key
      changes.updatedAt = now
      changes.paymentReady = true
      fanout[`transactions/${transaction.key}/updatedBy`] =
        users.currentUser.key
      fanout[`transactions/${transaction.key}/updatedAt`] = now
      fanout[`transactions/${transaction.key}/paymentReady`] = true
      return firebase
        .update(fanout)
        .then(() => {
          return dispatch({
            type: SELECT_CURRENT_TRANSACTION,
            payload: changes
          })
        })
        .then(res => resolve(dispatch(showModal(MODAL_CLIENT_PAYMENT))))
        .catch(err => {
          console.error(err)
          return reject(dispatch(cancelPaymentModal(transaction)))
        })
    })
  }
}

export function cancelPaymentModal(transaction) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const changes = { ...transaction }
    const fanout = {}
    if (transaction.type === 'POOL') {
      const total = calculTotalBillard(changes)
      if (total !== Number(transaction.pool.total)) {
        changes.pool.total = total
        fanout[`transactions/${transaction.key}/pool/total`] = total
      }
      changes.pool.sync = false
      fanout[`transactions/${transaction.key}/pool/sync`] = false
    }
    changes.paymentReady = false
    fanout[`transactions/${transaction.key}/paymentReady`] = false
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
    // dispatch(updateTransaction(transaction, changes))
  }
}
export function addPayment(transaction, payment) {
  return (dispatch, getState) => {
    const { users, firebase } = getState()
    const fanout = {}
    const key = firebase
      .child(`transactions/${transaction.key}/payments/`)
      .push().key
    payment.createdBy = users.currentUser.key
    payment.createdAt = moment().format()
    payment.updatedBy = users.currentUser.key
    payment.updatedAt = moment().format()
    fanout[`transactions/${transaction.key}/payments/${key}`] = payment
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function removePayment(transaction, payment) {
  return (dispatch, getState) => {
    const { firebase, users } = getState()
    const changes = { payments: { ...transaction.payments } }
    delete changes.payments[payment.key]
    firebase
      .child(
        `transactions/${transaction.key}/payments/${payment.key}/deletedBy`
      )
      .transaction(
        currentData => {
          return users.currentUser.key
        },
        (error, committed, snapshot) => {
          if (error) {
            Rollbar.error(error)
            return
          }
          const fanout = {
            [`transactions/${transaction.key}/payments/${payment.key}`]: null
          }
          return firebase.update(fanout, error => {
            if (error) {
              Rollbar.error(error)
            }
          })
        }
      )
  }
}
function transfertToBarTransaction(transaction, bar) {
  return (dispatch, getState) => {
    let changes
    if (transaction.type === 'BAR') {
      changes = { ...bar.currentTransaction }
      changes = {
        ...changes,
        products: { ...changes.products, ...transaction.products },
        payments: { ...changes.payments, ...transaction.payments }
      }
      return dispatch(updateTransaction(bar.currentTransaction, changes)).then(
        () => {
          return dispatch(
            transfertOriginTransaction(transaction, changes.sale_id)
          )
        }
      )
    } else if (transaction.type === 'POOL') {
      changes = { ...bar.currentTransaction }
      changes = {
        ...changes,
        isSided: false,
        products: { ...changes.products, ...transaction.products }
      }
      changes = {
        ...changes,
        pool: { ...transaction.pool },
        products: {
          ...transaction.products,
          ...bar.currentTransaction.products
        },
        payments: {
          ...transaction.payments,
          ...bar.currentTransaction.payments
        }
      }
      const now = moment().format()
      let totals = calculsTransaction(changes)
      if (!changes.pool.cycles[changes.pool.cycles.length - 1].endDate) {
        changes.pool.isPaused = true
        changes.pool.cycles[changes.pool.cycles.length - 1].pauseDate = now
        changes.pool.cycles[changes.pool.cycles.length - 1].endDate = now
      }
      totals = calculsTransaction(changes)
      changes.pool.totalElapsed = totals.elapsed
      if (totals.totalBillard !== Number(transaction.pool.total)) {
        changes.pool.total = totals.totalBillard
        changes.pool.transfert = null
      }
      changes.pool.table = null
      return dispatch(updateTransaction(bar.currentTransaction, changes)).then(
        () => {
          return dispatch(
            transfertOriginTransaction(
              transaction,
              changes.sale_id,
              changes.pool.total
            )
          )
        }
      )
    }
  }
}
function transfertToPoolTransaction(transaction, table) {
  return (dispatch, getState) => {
    let changes = { ...transaction }
    let totals
    if (table.currentTransaction) {
      changes = { ...table.currentTransaction }
      changes = {
        ...changes,
        products: { ...changes.products, ...transaction.products },
        payments: {
          ...changes.payments,
          ...transaction.payments
        }
      }
      if (transaction.type === 'POOL') {
        dispatch({
          type: LOADING_TABLE,
          tableKey: transaction.pool.table.key
        })
        dispatch({
          type: LOADING_TABLE,
          tableKey: table.key
        })

        const now = moment().format()
        totals = calculsTransaction(transaction)
        if (
          !transaction.pool.cycles[transaction.pool.cycles.length - 1].endDate
        ) {
          if (transaction.pool.isPaused) {
            const currentCycle =
              transaction.pool.cycles[transaction.pool.cycles.length - 1]
            const breakPeriod = moment(now).diff(currentCycle.pauseDate)
            transaction.pool.cycles[
              transaction.pool.cycles.length - 1
            ].endDate = now
            transaction.pool.cycles[
              transaction.pool.cycles.length - 1
            ].pauseDate = null
            transaction.pool.cycles[
              transaction.pool.cycles.length - 1
            ].breakPeriod += breakPeriod
          } else {
            transaction.pool.isPaused = true
            transaction.pool.cycles[
              transaction.pool.cycles.length - 1
            ].pauseDate = now
            transaction.pool.cycles[
              transaction.pool.cycles.length - 1
            ].endDate = now
          }
        }
        totals = calculsTransaction(transaction)
        transaction.pool.totalElapsed = totals.elapsed
        let totalTransfert = transaction.pool.transfert
          ? transaction.pool.transfert.total + totals.totalCurrentBillard
          : totals.totalCurrentBillard
        totalTransfert +=
          changes.pool.transfert && changes.pool.transfert.total
            ? changes.pool.transfert.total
            : 0
        changes = {
          ...changes,
          pool: {
            ...changes.pool,
            transfert: {
              ...changes.pool.transfert,
              total: _.round(totalTransfert, 1)
            }
          }
        }
        return dispatch(
          updateTransaction(table.currentTransaction, changes)
        ).then(() => {
          return dispatch(
            transfertOriginTransaction(
              transaction,
              changes.sale_id,
              totalTransfert
            )
          )
        })
      } else if (transaction.type === 'BAR') {
        dispatch({
          type: LOADING_TABLE,
          tableKey: table.key
        })
        if (transaction.pool) {
          const transfertTotal = transaction.pool.transfert
            ? _.round(
                transaction.pool.transfert.total + transaction.pool.total,
                1
              )
            : _.round(transaction.pool.total, 1)
          changes = {
            ...changes,
            pool: {
              ...changes.pool,
              transfert: { ...changes.pool.transfert, total: transfertTotal }
            }
          }
        }
        return dispatch(
          updateTransaction(table.currentTransaction, changes)
        ).then(() => {
          return dispatch(
            transfertOriginTransaction(transaction, changes.sale_id)
          )
        })
      }
      return
    }
    if (
      transaction.type === 'POOL' &&
      (transaction.pool.table || {}).type === table.type
    ) {
      dispatch({
        type: LOADING_TABLE,
        tableKey: table.key
      })
      changes = { ...changes, pool: { ...transaction.pool, table: table } }
      dispatch(removeTransactionFromTable(transaction.pool.table))
      dispatch(updateTransaction(transaction, changes))
    } else if (
      transaction.type === 'POOL' &&
      (transaction.pool.table || {}).type !== table.type
    ) {
      dispatch({
        type: LOADING_TABLE,
        tableKey: table.key
      })
      changes = { ...changes, pool: { ...changes.pool, table: table } }
      const pricings = getState().pricings.list
      const currentCycle = changes.pool.cycles[changes.pool.cycles.length - 1]
      const pricing = pricings.find(p => p.key === currentCycle.pricing.key)
      let newCycles = [...changes.pool.cycles]
      if (pricing.type === 1) {
        newCycles[newCycles.length - 1].tableType = table.type
      } else {
        newCycles = addCycle(changes, pricing)
      }
      changes = { ...changes, pool: { ...changes.pool, cycles: newCycles } }
      const total = calculTotalBillard(changes)
      if (total !== Number(changes.pool.total)) {
        changes.pool.total = total
      }
      dispatch(removeTransactionFromTable(transaction.pool.table))
      dispatch(updateTransaction(transaction, changes))
    } else if (transaction.type === 'BAR') {
      const barToDelete = { ...transaction.bar }
      const pricing = getState().settings.currentPricing
      const playersList = getState().players.list
      const players = playersList.map(p => {
        if (p.name === 'Normal') {
          return { ...p, count: 1 }
        }
        return { ...p, count: 0 }
      })
      const now = moment().format()
      changes = {
        ...changes,
        bar: null,
        type: 'POOL',
        isSided: false,
        pool: {
          table: table,
          total: 0,
          cycles: [
            {
              key: 0,
              startDate: now,
              breakPeriod: 0,
              playersCount: 1,
              players: players,
              tableType: table.type,
              total: 0,
              pricing: {
                key: pricing.key,
                name: pricing.name,
                type: pricing.type,
                value: pricing[table.type]
              }
            }
          ]
        }
      }
      if (transaction.pool) {
        changes.pool.id_sale_product_detail =
          transaction.pool.id_sale_product_detail
        const transfertTotal = transaction.pool.transfert
          ? _.round(
              transaction.pool.transfert.total + transaction.pool.total,
              1
            )
          : _.round(transaction.pool.total, 1)
        changes.pool.transfert = { total: transfertTotal }
      }
      const total = calculTotalBillard(changes)
      if (total !== Number(changes.pool.total)) {
        changes.pool.total = total
      }
      return dispatch(updateTransaction(transaction, changes)).then(() => {
        return dispatch(deleteBar(barToDelete))
      })
    }
  }
}
export function transfertTransaction(transaction, target, targetType) {
  return (dispatch, getState) => {
    if (!target.currentTransaction && targetType === 'POOL') {
      dispatch(transfertToPoolTransaction(transaction, target))
    } else if (target.currentTransaction && targetType === 'POOL') {
      dispatch(transfertToPoolTransaction(transaction, target))
    } else if (target.currentTransaction && targetType === 'BAR') {
      dispatch(transfertToBarTransaction(transaction, target))
    }
  }
}

export function selectCurrentTransaction(key, type) {
  return (dispatch, getState) => {
    const { transactions } = getState()
    let transac
    if (type === 'POOL') {
      transac = transactions.list.filter(t => {
        return t.type === type && t.pool.table.key === key
      })[0]
    } else if (type === 'BAR') {
      transac = transactions.list.filter(t => {
        return t.type === 'BAR' && t.bar.key === key
      })[0]
    }
    if (transac) {
      dispatch({
        type: SELECT_CURRENT_TRANSACTION,
        payload: transac
      })
    }
  }
}
export function playTransaction(transaction) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const fanout = {}
    if (transaction.pool.isPaused) {
      const currentCycle =
        transaction.pool.cycles[transaction.pool.cycles.length - 1]
      const breakPeriod = moment(moment()).diff(currentCycle.pauseDate)
      const cycles = [...transaction.pool.cycles]

      cycles[transaction.pool.cycles.length - 1].endDate = null
      cycles[transaction.pool.cycles.length - 1].pauseDate = null
      cycles[transaction.pool.cycles.length - 1].breakPeriod += breakPeriod
      fanout[`transactions/${transaction.key}/pool/isPaused`] = false
      fanout[`transactions/${transaction.key}/pool/cycles`] = cycles
      return firebase.update(fanout, error => {
        if (error) {
          Rollbar.error(error)
        }
      })
    }
  }
}
export function pauseTransaction(transaction) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const fanout = {}
    const cycles = [...transaction.pool.cycles]
    cycles[transaction.pool.cycles.length - 1].pauseDate = moment().format()
    fanout[`transactions/${transaction.key}/pool/isPaused`] = true
    fanout[`transactions/${transaction.key}/pool/cycles`] = cycles
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
function transfertOriginTransaction(transaction, targetSaleId, totalTransfert) {
  return (dispatch, getState) => {
    const { firebase, users } = getState()
    const fanout = {}
    fanout[`transactions/${transaction.key}/updatedBy`] = users.currentUser.key
    fanout[`transactions/${transaction.key}/updatedAt`] = moment().format()
    fanout[`transactions/${transaction.key}/transfertTo`] = targetSaleId
    if (totalTransfert) {
      fanout[`transactions/${transaction.key}/pool/total`] = totalTransfert
    }
    fanout[`transactions/${transaction.key}/closing`] = true
    firebase.update(fanout, error => {
      if (error) {
        Rollbar.error('ERROR @ transfertTransaction :', error)
        dispatch({
          type: UPDATE_TRANSACTION_ERROR,
          payload: error
        })
      }
    })
  }
}
export function cancelTransaction(transaction) {
  return (dispatch, getState) => {
    const { firebase, users } = getState()
    if (transaction.pool && transaction.type === 'POOL') {
      dispatch({
        type: LOADING_TABLE,
        tableKey: transaction.pool.table.key
      })
    }
    const fanout = {}
    fanout[`transactions/${transaction.key}/updatedBy`] = users.currentUser.key
    fanout[`transactions/${transaction.key}/updatedAt`] = moment().format()
    fanout[`transactions/${transaction.key}/canceled`] = true
    fanout[`transactions/${transaction.key}/closing`] = true
    firebase.update(fanout, error => {
      if (error) {
        Rollbar.error('ERROR @ cancelTransaction :', error)
        dispatch({
          type: UPDATE_TRANSACTION_ERROR,
          payload: error
        })
      }
    })
  }
}
export function closeTransaction(transaction) {
  return (dispatch, getState) => {
    if (transaction.pool && transaction.type === 'POOL') {
      dispatch({
        type: LOADING_TABLE,
        tableKey: transaction.pool.table.key
      })
    }
    dispatch(deleteTransaction(transaction))
  }
}

// ------------------------------------
// Basic Actions
// ------------------------------------
export function createTransactionForPool(table, pricing, players, user) {
  return (dispatch, getState) => {
    const { firebase, settings } = getState()
    const zDate =
      settings.currentDates && settings.currentDates.startDate
        ? moment(settings.currentDates.startDate).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
    const fanout = {}
    const transac = createNewTransactionForPool(
      table,
      pricing,
      players,
      user,
      zDate
    )
    const transacKey = firebase.child('transactions').push().key
    fanout[`transactions/${transacKey}`] = transac
    dispatch({
      type: LOADING_TABLE,
      tableKey: table.key
    })
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ createTransaction :', error)
        dispatch({
          type: CREATE_TRANSACTION_ERROR,
          payload: error
        })
      }
    })
  }
}
export function createTransactionForBar(bar) {
  return (dispatch, getState) => {
    const { firebase, users, settings } = getState()
    const fanout = {}
    const zDate =
      settings.currentDates && settings.currentDates.startDate
        ? moment(settings.currentDates.startDate).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
    const transac = createNewTransactionForBar(bar, users.currentUser, zDate)
    const transacKey = firebase.child('transactions').push().key
    fanout[`transactions/${transacKey}`] = transac
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ createTransaction :', error)
        dispatch({
          type: CREATE_TRANSACTION_ERROR,
          payload: error
        })
        return
      }
      dispatch({
        type: UPDATE_BAR_SUCCESS,
        payload: { ...bar, currentTransaction: transac }
      })
    })
  }
}

export function deleteTransaction(transaction) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const fanout = {}
    fanout[`transactions/${transaction.key}/closing`] = true
    firebase.child(`transactions/${transaction.key}/closing`).transaction(
      currentData => {
        return true
      },
      (error, committed, snapshot) => {
        if (error) {
          Rollbar.error(error)
          return
        }
        const fanout = {
          [`transactions/${transaction.key}`]: null
        }
        return firebase.update(fanout, error => {
          if (error) {
            Rollbar.error(error)
            return
          }
          if (transaction.type === 'POOL') {
            dispatch({
              type: UPDATE_TABLE_SUCCESS,
              payload: { ...transaction.pool.table }
            })
          } else if (transaction.type === 'BAR') {
            dispatch({
              type: DELETE_BAR_SUCCESS,
              payload: { ...transaction.bar }
            })
          }
        })
      }
    )
  }
}

export function updateTransaction(transaction, changes) {
  return (dispatch, getState) => {
    if (!transaction || !transaction.key) {
      console.error('UNDEFINED TRANSACTION', transaction, changes)
      return Promise.reject(new Error('UNDEFINED TRANSACTION'))
    }
    const { firebase } = getState()
    const fanout = {}
    fanout[`transactions/${transaction.key}`] = { ...transaction, ...changes }
    return firebase.update(fanout)
  }
}

export function registerTransactionListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('transactions')
    ref.on('child_added', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_TRANSACTION_SUCCESS,
        payload: payload
      })
    })
    ref.on('child_changed', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: UPDATE_TRANSACTION_SUCCESS,
        payload: payload
      })
    })
    ref.on('child_removed', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: DELETE_TRANSACTION_SUCCESS,
        payload: payload
      })
    })
  }
}
export const actions = {
  addSideTable,
  createTransactionForPool,
  createTransactionForBar,
  updateTransaction,
  registerTransactionListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_TRANSACTION_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(transac => transac.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    let sidedList = list.filter(transac => {
      return transac.isSided
    })
    sidedList = sidedList.sort(
      (a, b) => parseInt(a.pool.table.num, 10) - parseInt(b.pool.table.num, 10)
    )
    return Object.assign({}, state, {
      list: list,
      sidedList: sidedList,
      currentTransaction: state.currentTransaction
    })
  },
  [CREATE_TRANSACTION_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_TRANSACTION_SUCCESS]: (state, action) => {
    let list = state.list.map(transac => {
      return transac.key === action.payload.key ? action.payload : transac
    })
    let sidedList = list.filter(
      transac => transac.type === 'POOL' && transac.pool && transac.isSided
    )
    sidedList = sidedList.sort(
      (a, b) => parseInt(a.pool.table.num, 10) - parseInt(b.pool.table.num, 10)
    )
    const currentTransaction =
      state.currentTransaction &&
      state.currentTransaction.key === action.payload.key
        ? action.payload
        : state.currentTransaction
    return Object.assign({}, state, {
      list: list,
      sidedList: sidedList,
      currentTransaction: currentTransaction
    })
  },
  [DELETE_TRANSACTION_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_TRANSACTION_SUCCESS]: (state, action) => {
    let list = state.list.filter(transac => {
      return transac.key !== action.payload.key
    })
    let sidedList = list.filter(transac => transac.pool && transac.isSided)
    sidedList = sidedList.sort(
      (a, b) => parseInt(a.pool.table.num, 10) - parseInt(b.pool.table.num, 10)
    )
    const currentTransaction =
      state.currentTransaction &&
      state.currentTransaction.key === action.payload.key
        ? void 0
        : state.currentTransaction
    return Object.assign({}, state, {
      list: list,
      sidedList: sidedList,
      currentTransaction: currentTransaction
    })
  },
  [UPDATE_TRANSACTION_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_CURRENT_TRANSACTION]: (state, action) =>
    Object.assign({}, state, { currentTransaction: action.payload }),
  [CLEAR_CURRENT_TRANSACTION]: (state, action) =>
    Object.assign({}, state, { currentTransaction: void 0 })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], sidedList: [], currentTransaction: void 0 }
export default function transactionReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/transaction.js